import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import GModal from 'tennders-market/common/components/element/GModal'
import { StateType } from 'tennders-common/types/StateType'
import { dispatchWelcomeModal } from 'tennders-common/stores/modal/action'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import GHref from 'tennders-market/common/components/element/GHref'
import useInitials from 'tennders-common/hooks/useInitials'
import styles from '@/styles/AddNewCompany.module.scss'

const WelcomeModal = (props) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const router = useRouter()
  const { type } = router.query
  const modal = useSelector((state:StateType) => state.modal.welcomeModal)
  const { boxOwner } = useInitials()
  const box_owner = boxOwner?.teamName

  const close = () => {
    dispatch(dispatchWelcomeModal(null))
    router.push('/')
  }

  // useEffect(() => {
  //   if (modal) {
  //     setTimeout(() => {
  //       close()
  //     },
  //     3000)
  //   }
  // }, [modal])

  return (
    <GModal
      size={600}
      isOpen={!!modal}
      close={close}
      {...props}
    >
      <div className="tennders-modal-body w-100">
        <div className="text-24 bold mb-72 text-center">{t('auth:welcome_to', { box_owner })}</div>
        <div className="w-75 m-auto">
          <div className="text-20 mb-24 bold">{t('addBranch:next_steps')}</div>
          <ul className={styles['tennders-vertical-timeline']}>
            <li>
              <div className={styles.no}>1</div>
              <div className="text">
                {t('addBranch:our_team_will_validate')}
                <br />
                {t('addBranch:dont_worry_you_would', { type: t('addBranch:' + (type === 'shipper' ? 'loads' : 'trucks')) })}
              </div>
            </li>
            <li>
              <div className={styles.no}>2</div>
              <div className="text">
                {t('addBranch:once_your_account_is_verified')}
              </div>
            </li>
            <li>
              <div className={styles.no}>3</div>
              <div className="text">
                {t('addBranch:voila_your_are_all', { box_owner })}
              </div>
            </li>
          </ul>
          <div className="text-right">
            <GHref onClick={close} href={type === 'carrier' ? '/add/truck' : '/add/load'} className="btn standard-btn">
              {type === 'carrier' ? t('addTruck:addNewTruck') : t('addLoad:addNewLoad')}
            </GHref>
          </div>
        </div>
      </div>
    </GModal>
  )
}

export default WelcomeModal
